import React , {Component} from 'react';
import { Row } from 'antd';
import "../../asset/style/morpheus.css"
import "../../asset/style/landing.css"

export class Team extends Component {

    render(){
        return(
            <Row className="team-parent full-widther">
                Team
            </Row>
        )
    }
  }